import { render, staticRenderFns } from "./ModalFaqPergunta.vue?vue&type=template&id=5dd53fe6&"
import script from "./ModalFaqPergunta.vue?vue&type=script&lang=js&"
export * from "./ModalFaqPergunta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports